(() => {
  const initialize = () => {
    const bar = document.querySelector('[data-medi-mobile-purchase]');
    if (!bar || bar.dataset.initialized) return;
    const form = document.querySelector(`form[id^="main-product-atc-form${bar.dataset.productId}-"]`);
    const nativeButton = form?.querySelector('.main-product_atc-btn');
    if (!form || !nativeButton) return;
    bar.dataset.initialized = 'true';
    const button = bar.querySelector('[data-medi-purchase-action]');
    const spacer = document.querySelector('[data-medi-purchase-spacer]');
    const mobile = window.matchMedia('(max-width: 767px)');
    let scheduled = false;
    const update = () => {
      scheduled = false;
      const keyboardOpen = window.visualViewport && window.innerHeight - window.visualViewport.height > 150;
      const cartOpen = document.querySelector('modal-component.modal--active');
      const show = mobile.matches && nativeButton.getBoundingClientRect().bottom <= 0 && !keyboardOpen && !cartOpen;
      bar.hidden = !show;
      spacer.hidden = !show;
      if (show) {
        const height = `${bar.offsetHeight}px`;
        spacer.style.height = height;
        document.documentElement.style.setProperty('--medi-purchase-bar-height', height);
      }
      if (bar.dataset.available === 'true') {
        button.disabled = nativeButton.disabled;
        button.textContent = bar.dataset.addLabel;
      } else {
        button.disabled = false;
        button.textContent = bar.dataset.notifyLabel;
      }
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(update);
    };
    button.addEventListener('click', () => {
      if (bar.dataset.available === 'true') {
        if (!nativeButton.disabled) nativeButton.click();
      } else {
        const notifyButton = document.querySelector('.BIS_trigger');
        if (notifyButton) notifyButton.click();
        else nativeButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      schedule();
    });
    const visibilityObserver = new IntersectionObserver(schedule);
    visibilityObserver.observe(nativeButton);
    const formObserver = new MutationObserver(schedule);
    formObserver.observe(form, { attributes: true, childList: true, subtree: true });
    const bodyObserver = new MutationObserver(schedule);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    window.visualViewport?.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(form)) return;
      visibilityObserver.disconnect();
      formObserver.disconnect();
      bodyObserver.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      mobile.removeEventListener('change', schedule);
      window.visualViewport?.removeEventListener('resize', schedule);
      bar.remove();
      spacer.remove();
    }, { once: true });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
